import React from 'react';
import './Prices.scss';
import { pricelist } from './pricelist';

export const Prices = () => {
  
  return (
    <div className="prices container">
      {pricelist.map((list) => (
        <div key={list.id} className="price-category">
            <div className="price-header">
                <div className="price-header-item">{list.title}</div>
                <div className="price-header-item">Cena</div>
            </div>
            <div className="price-table">
            {list.prices.map((item, index) => {
              
              return (
                <div key={index} className={`price-row ${item.disable_background ? 'disable-background' : ''}`}>
                  <div className="price-item bold">
                    {item.title}
                  </div>
                  <div className="price-item">
                    {item.price}
                    {item.prices}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  );
};